<template lang="pug">
  .dialog-container(id="AddMassDevice-container")
    el-row.row
      el-col.col-middle(:span="24")
        el-button.confirm(id="AddMassDevice-createButton" v-if='!saving', type="success", plain, @click="createDevices()", circle, :disabled='!__formIsValid()')
          | &nbsp; {{$t("Create")}} &nbsp;
          font-awesome-icon.linker-icon(icon="magic")
        el-button.confirm.spinner(v-if='saving', type="primary", disabled, circle)
          font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
          .spinner-text {{ percentDone }}%
    el-row.row
      el-col.col-left(:span="24")
        h4 {{$t('Create a number (max. 999) of devices with following rules')}}:
        hr.header
        el-form(ref="form", label-width="300px")
          el-form-item(:label='$t("Template")')
            el-select(id="AddMassDevice-templateSelect" v-model='templateId', placeholder='Select', clearable)
              el-option(v-for='template in templates', :key='template.id', :label='template.name', :value='template.id', :id="'AddMassDevice-templateOption' + template.id")
          el-form-item
            span.warning {{ $t("Name consists of text part and numerical part to start from, separated by underscore eg.:") }} "sample device_22"
          el-form-item(:label='$t("Naming convention")')
            el-input(id="AddMassDevice-nameInput" v-model='deviceNameString', placeholder='Text part', style='width:300px')
            span _
            el-input-number(id="AddMassDevice-numberStartInput" v-model='deviceNameNumber', :min='1', :max='999', :title='$t("Numeration to start from")', controls-position="right")
          el-form-item(:label='$t("Number of devices to be created")')
            el-input-number(id="AddMassDevice-numberOfDevicesInput" v-model='deviceAmount', :min='1', :max='999', :title='$t("Number off device to add")', controls-position="right")
          el-form-item(:label='$t("Pad leading zeros")')
            el-checkbox(v-model="padLeadingZeros")
        hr.header
        h4(v-if='__formIsValid() && deviceAmount > 4') {{ $t('Examples of names of devices that will be created:') }}
        span(
          v-if='__formIsValid() && deviceAmount > 4',
          v-for="name of createExampleNames()"
          ) &nbsp; {{ name }} &nbsp;
</template>

<script>

import Vue from 'vue'

export default {
  props: [],
  components: {
  },
  async created () {
    await this.getDeviceTemplates()
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      percentDone: 0,
      templates: undefined,
      templateId: undefined,
      deviceNameString: undefined,
      deviceNameNumber: 1,
      deviceAmount: 1,
      padLeadingZeros: false
    }
  },
  methods: {
    __formIsValid () {
      if (
        this.templateId &&
        this.deviceNameString &&
        this.deviceNameNumber >= 0 &&
        this.deviceAmount > 0
      ) {
        return true
      }
      return false
    },
    async getDeviceTemplates () {
      await Vue.axios.get('devicetemplate')
        .then(response => {
          this.templates = response.data
        })
    },
    createExampleNames () {
      const exampleNames = []
      const half = parseInt(this.deviceAmount / 2)
      for (let index = half - 3; index < half; index++) {
        const iterator = parseInt(this.deviceNameNumber) + index
        exampleNames.push(`${this.deviceNameString}_${this.__padLeadingZeros(iterator)}`)
      }
      return exampleNames
    },
    async createDevices () {
      this.saving = true
      for (let index = 0; index < this.deviceAmount; index++) {
        const iterator = parseInt(this.deviceNameNumber) + index
        await this.createDeviceFromTemplate(`${this.deviceNameString}_${this.__padLeadingZeros(iterator)}`)
        this.percentDone = parseInt(((index + 1) / this.deviceAmount) * 100)
      }
      this.saving = false
      this.percentDone = 0
      await this.$store.dispatch('Device/getDeviceList')
    },
    __padLeadingZeros (num) {
      if (!this.padLeadingZeros) {
        return num
      }
      var s = num + ''
      while (s.length < 3) s = '0' + s
      return s
    },
    async createDeviceFromTemplate (name) {
      await Vue.axios
        .post('deviceTemplate/createDeviceFromDeviceTemplate', {
          name,
          deviceTemplate: this.templateId
        })
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../Linker/dialog.scss";
.tag-used {
  min-width: 50px;
  margin: 0px 3px;
  text-align: center;
}
.confirm {
  &.spinner {
    .spinner-icon {
      font-size: 40px;
      margin-top: -5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/AddMassDevice.vue